/**
 * How long ago a model version went live, in plain words (Apal 2026-11-02:
 * "with version # days ago months ago years ago"): today, yesterday,
 * N days ago, N months ago, N years ago. Calendar days, so it never
 * flickers with the time of day.
 */
const DAY = 86400000;

export function ageLabel(isoDate, today = new Date()) {
  if (!isoDate) return null;
  const d = new Date(isoDate + 'T00:00:00');
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const days = Math.round((t - d) / DAY);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days} days ago`;
  const months = Math.round(days / 30.44);
  if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
  const years = Math.round(days / 365.25);
  return `${years} year${years === 1 ? '' : 's'} ago`;
}
